import React from "react";
import { useDispatch } from "react-redux";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { deleteUserTravelVisa } from "Bands/state";

const { userTravelVisa: visaCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserTravelVisaModal: React.FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserTravelVisa(id));
  };

  return (
    <DeleteUserEntityModal
      type="travel visa/work permit"
      action={USER_ACTIONS.deleteUserTravelVisa}
      successMessage={visaCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
